export const menuRoles = {
    itensMenu: {
        conteudo: {
            roles: [
                'CONTEUDOS_CATALOGO_DELETAR',
                'CONTEUDOS_CATALOGO_SALVAR',
                'CONTEUDOS_CATALOGO_VISUALIZAR',
                'CONTEUDOS_ENTIDADE_VISUALIZAR',
                'CONTEUDOS_ENTIDADE_SALVAR',
                'CONTEUDOS_ENTIDADE_DELETAR'
            ],
            catalogo: {
                visualizar: ['CONTEUDOS_CATALOGO_VISUALIZAR'],
                salvar: ['CONTEUDOS_CATALOGO_SALVAR'],
                deletar: ['CONTEUDOS_CATALOGO_DELETAR']
            },
            entidade: {
                visualizar: ['CONTEUDOS_ENTIDADE_VISUALIZAR'],
                salvar: ['CONTEUDOS_ENTIDADE_SALVAR'],
                deletar: ['CONTEUDOS_ENTIDADE_DELETAR']
            }
        },
        integracoes: {
            roles: [
                'INTEGRACOES_GONEXTTX_SALVAR',
                'INTEGRACOES_GONEXTTX_VISUALIZAR',
                'INTEGRACOES_GONEXTTX_DELETAR',
                'INTEGRACOES_INFORMACOES-MANUAIS_VISUALIZAR',
                'INTEGRACOES_INFORMACOES-MANUAIS_SALVAR',
                'INTEGRACOES_INFORMACOES-MANUAIS_DELETAR',
                'INTEGRACOES_PARTICIPANTES_DELETAR',
                'INTEGRACOES_PARTICIPANTES_VISUALIZAR',
                'INTEGRACOES_PARTICIPANTES_SALVAR',
                'INTEGRACOES_RECIBOS-MANUAIS_DELETAR',
                'INTEGRACOES_RECIBOS-MANUAIS_SALVAR',
                'INTEGRACOES_RECIBOS-MANUAIS_VISUALIZAR',
                'INTEGRACOES_REGISTRO-AUTORAL_VISUALIZAR',
                'INTEGRACOES_REGISTRO-AUTORAL_SALVAR',
                'INTEGRACOES_REGISTRO-AUTORAL_DELETAR',
                'INTEGRACOES_REGISTRO-MARCARIO_VISUALIZAR',
                'INTEGRACOES_REGISTRO-MARCARIO_SALVAR',
                'INTEGRACOES_REGISTRO-MARCARIO_DELETAR',
                'INTEGRACOES_VENDAS_VISUALIZAR',
                'INTEGRACOES_VENDAS_DELETAR',
                'INTEGRACOES_VENDAS_SALVAR',
                'INTEGRACOES_SMUSICAL_SALVAR',
                'INTEGRACOES_SMUSICAL_DELETAR',
                'INTEGRACOES_SMUSICAL_VISUALIZAR'
            ],
            gonexttx: {
                visualizar: ['INTEGRACOES_GONEXTTX_VISUALIZAR'],
                salvar: ['INTEGRACOES_GONEXTTX_SALVAR'],
                deletar: ['INTEGRACOES_GONEXTTX_DELETAR']
            },
            infomanuais: {
                visualizar: ['INTEGRACOES_INFORMACOES-MANUAIS_VISUALIZAR'],
                salvar: ['INTEGRACOES_INFORMACOES-MANUAIS_SALVAR'],
                deletar: ['INTEGRACOES_INFORMACOES-MANUAIS_DELETAR']
            },
            participantes: {
                visualizar: ['INTEGRACOES_PARTICIPANTES_VISUALIZAR'],
                salvar: ['INTEGRACOES_PARTICIPANTES_SALVAR'],
                deletar: ['INTEGRACOES_PARTICIPANTES_DELETAR']
            },
            recibosmanuais: {
                visualizar: ['INTEGRACOES_RECIBOS-MANUAIS_VISUALIZAR'],
                salvar: ['INTEGRACOES_RECIBOS-MANUAIS_SALVAR'],
                deletar: ['INTEGRACOES_RECIBOS-MANUAIS_DELETAR']
            },
            registroautoral: {
                visualizar: ['INTEGRACOES_REGISTRO-AUTORAL_VISUALIZAR'],
                salvar: ['INTEGRACOES_REGISTRO-AUTORAL_SALVAR'],
                deletar: ['INTEGRACOES_REGISTRO-AUTORAL_DELETAR']
            },
            registromarcario: {
                visualizar: ['INTEGRACOES_REGISTRO-MARCARIO_VISUALIZAR'],
                salvar: ['INTEGRACOES_REGISTRO-MARCARIO_SALVAR'],
                deletar: ['INTEGRACOES_REGISTRO-MARCARIO_DELETAR']
            },
            smusical: {
                visualizar: ['INTEGRACOES_SMUSICAL_VISUALIZAR'],
                salvar: ['INTEGRACOES_SMUSICAL_SALVAR'],
                deletar: ['INTEGRACOES_SMUSICAL_DELETAR']
            },
            vendasinternacionais: {
                visualizar: ['INTEGRACOES_VENDAS_VISUALIZAR'],
                salvar: ['INTEGRACOES_VENDAS_SALVAR'],
                deletar: ['INTEGRACOES_VENDAS_DELETAR']
            }
        },
        parametros: {
            roles: [
                'PARAMETROS_PARAMETRO_DELETAR',
                'PARAMETROS_PARAMETRO_VISUALIZAR',
                'PARAMETROS_PARAMETRO_SALVAR'
            ],
            parametro: {
                visualizar: ['PARAMETROS_PARAMETRO_VISUALIZAR'],
                salvar: ['PARAMETROS_PARAMETRO_SALVAR'],
                deletar: ['PARAMETROS_PARAMETRO_DELETAR']
            }
        },
        gestaoDeCargas: {
            roles: [
                'GESTAO-DE-CARGAS_REGISTRO-AUTORAL_DELETAR',
                'GESTAO-DE-CARGAS_REGISTRO-AUTORAL_SALVAR',
                'GESTAO-DE-CARGAS_REGISTRO-AUTORAL_VISUALIZAR',
                'GESTAO-DE-CARGAS_REGISTRO-MARCARIO_DELETAR',
                'GESTAO-DE-CARGAS_REGISTRO-MARCARIO_SALVAR',
                'GESTAO-DE-CARGAS_REGISTRO-MARCARIO_VISUALIZAR'
            ],
            registroautoral: {
                visualizar: ['GESTAO-DE-CARGAS_REGISTRO-AUTORAL_VISUALIZAR'],
                salvar: ['GESTAO-DE-CARGAS_REGISTRO-AUTORAL_SALVAR'],
                deletar: ['GESTAO-DE-CARGAS_REGISTRO-AUTORAL_DELETAR']
            },
            registromarcario: {
                visualizar: ['GESTAO-DE-CARGAS_REGISTRO-MARCARIO_VISUALIZAR'],
                salvar: ['GESTAO-DE-CARGAS_REGISTRO-MARCARIO_SALVAR'],
                deletar: ['GESTAO-DE-CARGAS_REGISTRO-MARCARIO_DELETAR']
            }
        }
    }
};
